// pages/EmailCallback.jsx
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const EmailCallback = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (code && state && window.opener) {
      // Send message to parent window
      window.opener.postMessage(
        {
          type: "oauth-callback",
          code,
          state,
        },
        window.location.origin,
      );
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-[#0C0E12] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white text-lg">Completing email connection...</p>
        <p className="text-gray-400 text-sm mt-2">
          You can close this window once complete
        </p>
      </div>
    </div>
  );
};

export default EmailCallback;
